import { render, staticRenderFns } from "./MinimalProfileForm.vue?vue&type=template&id=a81886e8"
import script from "./MinimalProfileForm.vue?vue&type=script&lang=ts"
export * from "./MinimalProfileForm.vue?vue&type=script&lang=ts"
import style0 from "./MinimalProfileForm.vue?vue&type=style&index=0&id=a81886e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports